import request from '@/utils/request'

// 服务类目列表
export function getServiceCategory(params) {
  return request({
    url:'market/category',
    method:'get',
    params
  })
}


// 获取服务列表
export function getServiceList(params) {
  return request({
    url:'market/list',
    method:'get',
    params
  })
}

// 获取服务商店铺列表
export function getSmchtshopList(params) {
  return request({
    url:'smchtshop/list',
    method:'get',
    params
  })
}
// 获取服务详情
export function getServiceDetail(params) {
  return request({
    url:'market/detail',
    method:'get',
    params
  })
}

// 获取服务商店铺信息
export function getSmchtshopDetail(params) {
  return request({
    url:'smchtshop/detail',
    method:'get',
    params
  })
}
